<template>
  <div class="activity-container">
    <!-- <div class="w-75rem m-auto mt-50 mb-50 bgc-w flex-1 ph-10"> -->

    <div class="w-75rem m-auto">
      <div class="mt-20">
        <myBreadCrumb :list="menuList" />
      </div>

      <!-- <div class="mt-20">
        <myRadio :selection="selection" @choice="changeType" />
      </div> -->
      <div
        class="mt-30 flex-row flex-wrap pb-30 bgc-w"
        v-if="activityList.length == 0"
      >
        <tabBar
          class="m-auto mt-20 w-90"
          title="赶大集"
          :type="1"
          :showMore="false"
          py="CHANG GUAN ZHAN SHI "
          @onClick="goPage('/venueList')"
        />
        <!-- <activityItem class="mt-20 mr-10 ml-10" v-for=" (item, index) of activityList" :activityType="item.activityType"
          :activityLocation="item.activityLocation" :activiytPosters="item.activiytPosters"
          :activityName="item.activityName" :startTime="item.startTime ? item.startTime.split(' ')[0] : ''"
          :endTime="item.endTime.split(' ')[0]" :state="item.state" :holder="item.holder" :key="index"
          @onClick="goPage('/activityDetails', { id: item.id })" /> -->
        <div class="marketItem" v-for="(item, index) in 8" :key="index">
          <el-image
            style="width: 100%; height: 300px"
            src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
            fit="cover"
          ></el-image>
          <div class="infoMask">
            <p class="infoName">集市名称</p>
          </div>
        </div>
      </div>
      <div class="mt-30 bgc-w pb-30" v-else>
        <el-empty
          description="暂无活动"
          image="https://culture-1303829981.cos.ap-shanghai.myqcloud.com/culture/common/miss.png"
        ></el-empty>
      </div>
      <div class="mh-30 flex-row flex-jsb">
        <div>共计 {{ total }} 条</div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="queryInfo.pageSize"
          :current-page.sync="queryInfo.pageNo"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  myRadio,
  myBreadCrumb,
  activityItem,
  tabBar,
} from "@/components/index.js";
import commmonApi from "@/api/request/common";
import activityApi from "@/api/request/activity";
export default {
  name: "activitylist",
  components: { myRadio, myBreadCrumb, activityItem, tabBar },
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        pageSize: 8,
      },
      total: 0,
      searchParams: {},
      // 顶部的目录
      menuList: [
        {
          path: "/market",
          name: "赶大集",
        },
        {
          // path: "/Activity",
          name: "物品列表",
        },
      ],
      activityList: [],
      selection: [],
    };
  },
  created() {
    this.getList();
    this.getClass();
  },
  methods: {
    changeType(e) {
      this.queryInfo = {
        pageNo: 1,
        pageSize: 8,
      };
      this.searchParams[e.type.value] = e.data;
      this.getList(this.searchParams);
    },
    handleCurrentChange(e) {
      this.queryInfo.pageNo = e;
      this.getList();
    },
    getList(params = {}) {
      activityApi
        .getActivityList({
          orderBy: "startTime",
          ...params,
          ...this.searchParams,
          ...this.queryInfo,
          isDelete: 1, //上架的产品
        })
        .then((res) => {
          if (res.success) {
            this.total = res.data.searchParams.total;
            // this.activityList = res.data.list;
          }
        });
    },
    // 获取顶部的选项
    getClass() {
      commmonApi
        .adminKey({
          keyName: "activity_list",
          keyType: "search_type",
        })
        .then((res) => {
          if (res.success) {
            res.data.list.map(async (item, index) => {
              commmonApi
                .adminKey({
                  keyType: item.keyValue,
                })
                .then((res2) => {
                  let arr = [];
                  res2.data.list.map(async (item2, index2) => {
                    arr.push({
                      label: item2.keyDescribe,
                      value: item2.keyValue,
                    });
                  });

                  this.$set(this.selection, index, {
                    type: item.keyDescribe,
                    value: item.keyValue,
                    data: arr,
                  });
                });
            });
          }
        });
    },
    goPage(e, query) {
      this.$router.push({
        path: e,
        query,
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../theme/myStyle.less"; //全局样式

.activity-container {
  flex: 1;
}
.marketItem {
  width: 250px;
  background-color: #fff4df;
  height: 300px;
  border: 4px solid #452a0e;
  border-radius: 4px;
  position: relative;
  margin: 20px 20px 0 20px;
  cursor: pointer;
}
.marketItem:hover {
  box-shadow: 4px 6px 7px 2px #00000091;
}
.infoMask {
  height: 60px;
  width: 100%;
  background: #0000006e;
  position: absolute;
  bottom: 0px;
  left: 0px;
  box-shadow: 2px 2px 2px 2px #000000;
  .infoName {
    color: #ffffff;
    font-size: 18px;
    line-height: 30px;
    text-align: left;
    padding: 3px;
  }
}
/deep/ .el-pagination.is-background .el-pager li {
  background: #fff;
}

/deep/ .btn-next,
/deep/ .btn-prev {
  background: #fff !important;
}
</style>